export function formatPhone(value: unknown): string {
  const original = String(value ?? "");
  let digits = original.replace(/\D/g, "");
  if (!digits) return "";
  if (
    (original.trim().startsWith("+") && !original.trim().startsWith("+7")) ||
    digits.length > 11 ||
    (digits.length === 11 && !/^[78]/.test(digits))
  )
    return original;
  if (
    original.trim().startsWith("+7") ||
    digits.length === 11 ||
    (digits.length < 10 && /^[78]/.test(digits))
  )
    digits = digits.slice(1);
  if (!digits) return "+7";
  let result = "+7 (" + digits.slice(0, 3);
  if (digits.length > 3) result += ") " + digits.slice(3, 6);
  if (digits.length > 6) result += "-" + digits.slice(6, 8);
  if (digits.length > 8) result += "-" + digits.slice(8, 10);
  return result;
}
export function phoneHref(value: unknown): string | undefined {
  let digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return undefined;
  if (digits.length === 10) digits = "7" + digits;
  else if (digits.length === 11 && digits.startsWith("8"))
    digits = "7" + digits.slice(1);
  return "tel:+" + digits;
}
export function validatePhone(value: unknown): string | undefined {
  if (!value) return undefined;
  return /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(formatPhone(value))
    ? undefined
    : "Введите полный номер: +7 (999) 999-99-99";
}
